import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, combineLatest, map, of } from 'rxjs';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { supplyContract } from 'src/app/interfaces/supplyContract';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditContractComponent implements OnInit {
  /**
   * The current User as an Object => set via URL
   */
  currentUser: BusinessUserResource;
  /***
   * Has the Page been loaded
   */
  loading: boolean = true;
  /**
   * The Form to edit the Contract
   */
  editContractForm: UntypedFormGroup;
  /**
   * the current Contract
   */
  currentContract: supplyContract;
  /**
   * The state of a Contract
   */
  supplyContractState = [
    { value: 'NEW', viewValue: 'Neu', 'state': true },
    { value: 'RUNNING', viewValue: 'Läuft', 'state': true },
    { value: 'CANCELLED', viewValue: 'Gekündigt', 'state': true },
    { value: 'FINISHED', viewValue: 'Beendet', 'state': true },
   // { value: 'DELETED', viewValue: 'Gelöscht', 'state': true },
  ]
  /**
   * The Types of Contracts
   */
  SupplyContractType = [
    { value: 'UNKNOWN', viewValue: 'unbekannt', 'state': true },
   // { value: 'ACCOUNT', viewValue: 'Vertragskonto', 'state': true },
    { value: 'POWER', viewValue: 'Strom', 'state': true },
    { value: 'GAS', viewValue: 'Gas', 'state': true },
    { value: 'WATER', viewValue: 'Wasser', 'state': true },
    { value: 'CABLE', viewValue: 'Kabel', 'state': true },
    { value: 'MOBILE', viewValue: 'Mobil', 'state': true },
    { value: 'HEAT', viewValue: 'Wärme', 'state': true },
    { value: 'PHOTOVOLTAIK', viewValue: 'Photovoltaik', 'state': true },
    { value: 'FIBER', viewValue: 'Glasfaser', 'state': true },
    { value: 'GARDENWATER', viewValue: 'Gartenwasser', 'state': true },
  ]

  /**
   * constructor
   * init the Forms
   * @param fb 
   * @param businessuserService 
   * @param breakpointObserver 
   * @param route 
   * @param router 
   * @param overlay 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private overlay: OverlayService) {
    //  Vertragstyp*	Vertragsnr.*	Zählernr.*	Gültig von	Gültig bis	Nicht ändern	Status
    this.editContractForm = this.fb.group({
      number: ['', [Validators.required]],
      measuringPointNumber: ['', [Validators.required]],
      validFrom: ['', []],
      validUntil: ['', []],
      contractType: ['', [Validators.required]],
      contractState: ['', [Validators.required]],
      locallyManaged: [false, []]
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUser(params['id']).pipe(
          catchError(err => of(err)),
        ),
        this.businessuserService.getContractData(params['id'], params['cid']).pipe(
          catchError(err => of(err)),
        )
      ]).pipe(
        map(([user, contract]: ([BusinessUserResource, supplyContract])) => {
          this.currentUser = user;
          this.currentContract = contract;
          this.editContractForm.patchValue(contract);
          if (contract.validFrom) {
            this.editContractForm.patchValue({
              validFrom: this.formatDate(contract.validFrom)
            })
          }
          if (contract.validUntil) {
            this.editContractForm.patchValue({
              validUntil: this.formatDate(contract.validUntil)
            })
          }
        })
      ).subscribe(() => {
        this.loading = false;
      })
    })
  }
  /**
   * edit the Contract for the User
   * @returns 
   */
  edit() {
    this.editContractForm.markAllAsTouched();
    if (this.editContractForm.invalid) {
      return;
    }
    let tempContract: supplyContract = this.currentContract;
    tempContract.number = this.editContractForm.value.number;
    tempContract.measuringPointNumber = this.editContractForm.value.measuringPointNumber;
    tempContract.validFrom = this.editContractForm.value.validFrom;
    tempContract.validUntil = this.editContractForm.value.validUntil;
    tempContract.contractType = this.editContractForm.value.contractType;
    tempContract.contractState = this.editContractForm.value.contractState;
    tempContract.locallyManaged = this.editContractForm.value.locallyManaged;
    this.businessuserService.editContractForUser(this.currentUser.publicId, this.currentContract).subscribe({
      next: () => {
        this.overlay.openSnackBar("Energieliefervertrag erfolgreich geändert!")
      },
      error: err => {
        this.overlay.openSnackBar("Fehler beim Speichern der Änderungen!", 'error')
        console.log(err)
      }
    })
  }
  /**
   * Formate the Data as YYYY-MM-DD
   * @param date 
   * @returns 
   */
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
}
